// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlanoContas_PercentualInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for PUT /planocontas/{id}/percentual
 *
 * Updates the percentage for a variable budget account.
 */
import { registerContract } from './validate'

export interface PlanoContas_PercentualInput {
percentual: number
}

registerContract('PlanoContas_PercentualInput', {
  percentual: { type: 'number',  required: true },
})
